<template>
	<div>
		<v-layout row wrap justify-end
			align-center class="header-booking-data">
			<v-flex xs2>
				<v-select
					class="filter-select"
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiary"
					hide-details
					single-line
					bottom
					@input="loadData">
				</v-select>
			</v-flex>
		</v-layout>
		<v-card
			class="pa-3 mb-3"
			height="auto">
			<v-layout row wrap>
				<v-flex xs12 text-xs-left mb-3>
					<label class="card-title">% Empresas Top</label>
				</v-flex>
				<v-flex xs4 pl-0 mb-2>
					<v-layout row wrap class="calendar-range">
						<v-flex md6 pa-0 class="border-right">
							<v-menu
								lazy
								v-model="menuStart"
								transition="scale-transition"
								offset-y
								full-width
								:nudge-left="40"
								class="menu-date-picker"
								max-width="290px">
								<v-text-field
									slot="activator"
									label="Picker in menu"
									v-model="dateStart"
									prepend-icon="event"
									:append-icon="arrowIconStart"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="dateStart"
									no-title
									scrollable
									@input="loadData">
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex md6 pa-0>
							<v-menu
								lazy
								v-model="menuEnd"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								max-width="290px">
								<v-text-field
									slot="activator"
									label="Picker in menu"
									v-model="dateEnd"
									:append-icon="arrowIconEnd"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="dateEnd"
									no-title
									scrollable
									@input="loadData">
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs3 mb-2>
					<v-select
						class="filter-select"
						:items="categories"
						item-text="name"
						item-value="id"
						v-model="category"
						hide-details
						single-line
						bottom
						@input="loadData">
					</v-select>
				</v-flex>
				<v-flex xs5 pl-0 mb-2>
					<v-select
						label="Productos"
						class="filter-select"
						autocomplete
						:async-loading="loading"
						single-line
						item-text="productSearching"
						:items="products"
						:search-input.sync="search"
						@input="addProducts"
						v-model="productSelected"
						></v-select>
				</v-flex>
				<v-flex xs12 pl-0 mb-4 text-xs-left>
					<v-chip
						v-for="(product, indexProduct) in productsSelected"
						:key="product.id"
						@input="removeProducts(indexProduct)"
						close>
						{{ product.productSearching }}
					</v-chip>
				</v-flex>
				<v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<table-run
							:columns="columns"
							:rows="rows"
							:include-delete="false"
							:include-export-to-excel="false"
							:include-options="false"
							:include-settings="false"
							:include-search="false"
							selectable
							class="no-selectable-table">
							<template slot="rows" scope="props">
								<td>{{ props.row.company }}</td>
								<td>{{ props.row.country}}</td>
								<td>{{ props.row.quantity}}</td>
								<td>{{ props.row.percentage }}</td>
								<td>{{ props.row.total }}</td>
							</template>
						</table-run>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-card>
		<v-card
			v-if="showChart"
			class="pa-3 mb-3"
			height="auto">
			<v-layout row wrap>
				<v-flex xs6 text-xs-left>
					<label class="card-title">% Empresa | APK Transportes</label>
				</v-flex>
				<v-flex xs6 text-xs-right>
					<v-layout class="search">
						<input type="text" placeholder="Buscar empresa">
						<v-icon class="grey--text">search</v-icon>
					</v-layout>	
					<v-btn
						icon
						class="grey--text"
						>
						<v-icon>insert_drive_file</v-icon>
					</v-btn>
					<v-btn
						icon
						class="grey--text">
						<v-icon>print</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<v-layout row wrap align-center>
								<v-flex xs2 pr-3
									v-for="year in years"
									:key="year.name">
									<v-layout row wrap align-center>
										<v-flex xs10 pr-0 text-xs-left>
											<span class="caption-color"
												:style="`background-color: ${year.color}`"></span>
											<label class="caption-text">{{ year.name }}</label>
										</v-flex>
										<v-flex xs2 pl-0 text-xs-right>
											<v-checkbox
												class="caption-checkbox"
											>
											</v-checkbox>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<vue-chart
						type="bar"
						:data="barData"
						:options="optionsChart"
						class="report-container"
					></vue-chart>
				</v-flex>
			</v-layout>
		</v-card>
		<v-card
			v-if="showChart"
			class="pa-3"
			height="auto">
			<v-layout row wrap>
				<v-flex xs6 text-xs-left>
					<label class="card-title">% Empresa | APK Transportes</label>
				</v-flex>
				<v-flex xs6 text-xs-right>
					<v-layout class="search">
						<input type="text" placeholder="Buscar empresa">
						<v-icon class="grey--text">search</v-icon>
					</v-layout>	
					<v-btn
						icon
						class="grey--text"
						>
						<v-icon>insert_drive_file</v-icon>
					</v-btn>
					<v-btn
						icon
						class="grey--text">
						<v-icon>print</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<v-layout row wrap align-center>
								<v-flex xs1 mr-3>
									<v-select
									class="filter-select mr3 select-date"
									v-bind:items="date"
									v-model="year">
									</v-select>
								</v-flex>
								<v-flex xs2 pr-3
									v-for="subsidiary in subsidiaries"
									:key="subsidiary.id">
									<v-layout row wrap align-center>
										<v-flex xs10 pr-0 text-xs-left>
											<span class="caption-color"
												:style="`background-color: ${subsidiary.color}`"></span>
											<label class="caption-text">{{ subsidiary.name }}</label>
										</v-flex>
										<v-flex xs2 pl-0 text-xs-right>
											<v-checkbox
												class="caption-checkbox"
												v-model="subsidiary.isSelected"
											>
											</v-checkbox>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs2 pr-3>
									<v-layout row wrap align-center>
										<v-flex xs10 pr-0 text-xs-left>
											<span class="caption-color average"></span>
											<label class="caption-text">PROMEDIO</label>
										</v-flex>
										<v-flex xs2 pl-0 text-xs-right>
											<v-checkbox
												class="caption-checkbox"
												v-model="average"
												:true-value="1"
					              :false-value="0"
											>
											</v-checkbox>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<vue-chart
						type="bar"
						:data="barData"
						:options="optionsChart"
						class="report-container"
					></vue-chart>
				</v-flex>
			</v-layout>
		</v-card>
	</div>
</template>

<script>
import { format, subDays } from 'date-fns';
import TableRun from 'table-run';
import VueChart from 'vuechart';
import helper from '@/shared/helper';

const helperMethods = helper.methods;

function created() {
	this.loadResources();
}

function addProducts() {
	const index = this.productsSelected.findIndex(ps => ps.id === this.productSelected.id) > -1;
	if (!index) {
		this.productsSelected.push(this.productSelected);
		this.loadData();
	}
}

function arrowIconEnd() {
	const arrowEnd = this.menuEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function arrowIconStart() {
	const arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

async function loadResources() {
	const request = [
		this.$http.get(`${process.env.PMS_URL}/hotel`),
		this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`),
	];
	const [subsidiaries, categories] = await Promise.all(request);
	this.subsidiaries = subsidiaries.data.data.map((sub, index) => {
		const newSub = { ...sub };
		if (index === 0) {
			newSub.color = '#04bee9';
		}
		if (index === 1) {
			newSub.color = '#00cb28';
		}
		newSub.isSelected = true;
		return newSub;
	});
	this.categories = categories.data;
	this.categories.unshift(this.filterTo);
	this.subsidiary = this.subsidiaries[0].id;
	this.category = this.categories[0].id;
}

async function loadData() {
	const stringProducts = this.productsSelected.map((element) => {
		const newProducts = [];
		newProducts.push(element.id);
		return newProducts;
	});
	const params = {
		dateStart: this.dateStart,
		dateEnd: this.dateEnd,
		idSubsidiary: this.subsidiary,
		products: stringProducts.toString(),
		idCategory: this.category,
	};
	const response = await this.$http.get(`${process.env.PMS_URL}/report-top?`, { params });
	this.rows = response.data.data.map((element) => {
		const newRows = {};
		newRows.company = element.fullName;
		newRows.country = element.country;
		newRows.quantity = element.quantityProducts;
		newRows.percentage = element.percentage;
		newRows.total = element.salesAmount;
		return newRows;
	});
}

function removeProducts(index) {
	this.productsSelected.splice(index, 1);
	this.loadData();
}

function search(val) {
	return val && this.searchProducts(val);
}

async function searchProducts(code) {
	const params = {
		code,
	};
	if (code) {
		const { data: products } = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products`, { params });
		this.products = products.map((product) => {
			const newProduct = { ...product };
			newProduct.productSearching = `${product.name} ${product.code}`;
			return newProduct;
		});
	}
}

function data() {
	return {
		filterTo: {
			id: '',
			name: 'Todos',
		},
		average: true,
		barData: {
			datasets: [{
				label: 'Lima',
				data: ['10', '10'],
				backgroundColor: ['red', 'red'],
			},
			{
				label: 'Arequipa',
				data: ['10', '10'],
				backgroundColor: ['#0fe270', '#0fe270'],
			}],
			labels: ['Julio 2017', 'Agosto 2017'],
		},
		categories: [],
		category: 0,
		columns: [
			{ id: 1, name: 'Empresas', code: 'company', isSortable: { down: false, up: false } },
			{ id: 2, name: 'Pais', code: 'country', isSortable: { down: false, up: false } },
			{ id: 3, name: 'Cantidad', code: 'quantity', isSortable: { down: false, up: false } },
			{ id: 4, name: 'Porcentaje', code: 'percentage', isSortable: { down: false, up: false } },
			{ id: 5, name: 'Monto total', code: 'total', isSortable: { down: false, up: false } },
		],
		date: ['2018', '2017'],
		dateEnd: format(new Date(), 'YYYY-MM-DD'),
		dateStart: format(subDays(new Date(), 1), 'YYYY-MM-DD'),
		loading: false,
		menuEnd: false,
		menuStart: false,
		optionsChart: {
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		},
		products: [],
		productSelected: {},
		productsSelected: [],
		rows: [
			{ company: 1, country: 'peru', quantity: 5, percentage: 50, total: 40 },
		],
		search: null,
		showChart: false,
		subsidiaries: [],
		subsidiary: 0,
		value: 0,
		year: '2018',
		years: [
			{ name: '2015', color: '#02861c' },
			{ name: '2016', color: '#04bee9' },
			{ name: '2017', color: '#0084f5' },
			{ name: '2018', color: '#d0021b' },
		],
	};
}

export default {
	name: 'report-company',
	components: {
		TableRun,
		[VueChart.name]: VueChart,
	},
	computed: {
		arrowIconEnd,
		arrowIconStart,
	},
	created,
	data,
	methods: {
		addProducts,
		loadResources,
		loadData,
		removeProducts,
		searchProducts: helperMethods.debounce(searchProducts),
	},
	watch: {
		search,
	},
};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 55px;
		width: calc(100% - 230px);
	}

	.search {
		border:1px solid map-get($colors, border-radio);
		border-radius:5px;
		display: inline-block;
		height: 35px;
		margin-right: 20px !important;
		padding: 5px;
		width: 274px;

		input {
			outline: none;
			width: 230px;
		}
	}

	.caption {
		&-color {
			display: inline-block;
			height: 12px;
			margin-right: 10px;
			vertical-align: middle;
			width: 12px;
		}

		&-checkbox {
			background-color: transparent;
			box-shadow: none;
			min-height: auto;
		}
	}

	.average {
		background-color: map-get($colors, check-average) !important;
	}

	.select-date {
		width: 100px;
	}

	.border-right {
		border-right: 1px solid map-get($colors, e-bg-icon);
	}	
</style>



// WEBPACK FOOTER //
// Company.vue?0e053a13